import React, { useState, useEffect } from "react";
import { Table } from "react-bootstrap";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

import PhaseCreate from "./PhaseCreate";
import PhasesFields from "./PhasesFields/PhasesFields";

import { useUpdatePhase } from "features/account/services";
import { useFetchPhases } from "features/account/services";
import { useDragAndDrop } from "features/protocols/hooks";

import Loader from "components/ui/Loader";
import ErrorHandler from "components/ui/ErrorHandler";
import RequiredAsterisk from "components/ui/RequiredAsterisk";
import EmptyStateHandler from "components/ui/EmptyStateHandler";

const StatusTracking = () => {
  const [droppableId, setDroppableId] = useState("droppable-id");
  const [isCreateButtonDisabled, setIsCreateButtonDisabled] = useState(false);
  const { error, isLoading, phases, setPhases, fetchPhases } = useFetchPhases();

  const onPhasesUpdated = () => fetchPhases();

  const { updatePhase } = useUpdatePhase({
    onPhaseUpdated: () => {
      onPhasesUpdated();
    },
  });

  const { onDragEnd } = useDragAndDrop({
    state: phases,
    stateSetter: setPhases,
    onReordered: (removed, order) => {
      updatePhase({
        phaseId: removed?.metaId,
        order,
        label: removed?.label,
      });
    },
  });

  useEffect(() => {
    setDroppableId("droppable-id-2");
  }, []);

  useEffect(() => {
    if (phases.length === 20) {
      setIsCreateButtonDisabled(true);
    }
  }, [phases]);

  return (
    <>
      <DragDropContext onDragEnd={onDragEnd}>
        <div className="d-flex flex-row mt-5">
          <div className="flex-fill">
            <h4>Status Tracker</h4>
          </div>
          <div>
            <PhaseCreate
              onPhaseCreated={onPhasesUpdated}
              isCreateButtonDisabled={isCreateButtonDisabled}
            />
          </div>
        </div>
        <hr />
        <Table size="sm">
          <thead>
            <tr>
              <th />
              <th />
              <th className="col-9">Phase name</th>
              <th className="col-3">Action</th>
            </tr>
          </thead>
          <Droppable isDropDisabled={false} droppableId={droppableId}>
            {(provided, snapshot) => (
              <tbody
                ref={provided.innerRef}
                {...provided.droppableProps}
                className={
                  snapshot.isDraggingOver
                    ? "bg-primary bg-opacity-10"
                    : "table-group-divider"
                }
              >
                <>
                  {isLoading ? (
                    <tr>
                      <td colSpan="7">
                        <Loader />
                      </td>
                    </tr>
                  ) : error ? (
                    <tr>
                      <td colSpan="7">
                        <ErrorHandler error={error} />
                      </td>
                    </tr>
                  ) : !phases || !phases.length ? (
                    <tr>
                      <td colSpan="7">
                        <EmptyStateHandler
                          title="No phases found"
                          description="There are currently no phases to show"
                        />
                      </td>
                    </tr>
                  ) : (
                    phases.map((phase, index) => (
                      <PhasesFields
                        key={phase?.metaId}
                        phase={phase}
                        onPhasesUpdated={onPhasesUpdated}
                        index={index}
                        statuses={phase?.statuses}
                        facilities={phase?.facilities}
                      />
                    ))
                  )}
                </>

                {provided.placeholder}
              </tbody>
            )}
          </Droppable>
        </Table>
      </DragDropContext>
      <div className="text-muted mb-2">
        <small>
          <RequiredAsterisk />
          Maximum 20 Phases allowed
        </small>
      </div>
    </>
  );
};

export default StatusTracking;
